export const primaryColor = '#040608'